const MAX_NOTIFICATION_NUMBER_TO_SHOW = 99;

export default class MethodUtils {

    constructor() {}

    updateApplicationNotificationEvery(appliFunction, time) {
        return window.setInterval(appliFunction, time);
    }

    getNotificationCounterToShow(actualCounterValue) {
        // If data cannot be cast to number, do not continue
        if (Number.isNaN(actualCounterValue)) {
            return actualCounterValue;
        }

        return (actualCounterValue > MAX_NOTIFICATION_NUMBER_TO_SHOW ? MAX_NOTIFICATION_NUMBER_TO_SHOW : actualCounterValue);
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/generic/methodUtils.js